import { useTracking } from '@change-corgi/core-react/tracking';

import { useGuideLinks, type GuideLink } from 'src/app/shared/hooks/useGuideLinks';

type Result = ModelHookResult<{ tips: readonly GuideLink[] }, { onTipLinkClick: (url: string) => void }>;

export function useTipsAndGuides(): Result {
	const tips = useGuideLinks() ?? [];

	const track = useTracking();

	return {
		data: { tips },
		actions: {
			onTipLinkClick: (url: string) => {
				void track('homepage_tips_and_guides_link_click', { url });
			},
		},
	};
}
